export function TableSkeleton({ cols, rows = 5 }: { cols: number; rows?: number }) {
  return (
    <>
      {Array.from({ length: rows }, (_, r) => (
        <tr key={r} style={{ borderBottom: '1px solid rgba(255,255,255,0.03)' }}>
          {Array.from({ length: cols }, (_, c) => (
            <td key={c} className="px-5 py-3.5">
              <div className="shimmer h-3.5 rounded w-full" style={{ opacity: 1 - r * 0.12 }} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
